// before the migration to WMF, we had "lazily loaded" backoffice uis,
// i.e. their js, css, and i18n related code loading was only added to the html, when one of the backoffice's routes was accessed;
// even though we now load the js dynamically as remote modules for each route via WMF,
// we can still lazily load the css and i18n code, as it is isolated from (i.e. not needed by) the regular sub uis
// we do the lazy loading of the css and the i18n files by this hook
import { AsyncLoader } from "../asyncLoader/AsyncLoader";
import { HOOK_SKIPPED } from "../hooks/redirectUtil";
export const loadedEnvironments: any[] = []; //exported for test only

function loadEnvironment(identifier) {
	if (loadedEnvironments.includes(identifier)) {
		return;
	}

	const paths = window.lazyEnvironment[identifier];
	return Promise.all([
		AsyncLoader.loadCss(paths.css).catch(error => {
			console.error("Could not load css for", identifier, error);
		}),
	]).then(() => {
		loadedEnvironments.push(identifier);
	});
}

const backofficeEnvironmentConfigs = [
	{
		pathPrefixes: ["/backoffice/personallists", "/backoffice/customer"],
		environmentIdentifier: "backofficeUiCa",
	},
	{
		pathPrefixes: ["/backoffice/bannermanagement", "/backoffice/ab-experiments", "/backoffice/storelistmanagement"],
		environmentIdentifier: "backofficeUiCi",
	},
	{
		pathPrefixes: ["/backoffice/store", "/backoffice/search", "/backoffice/category"],
		environmentIdentifier: "backofficeUiEx",
	},
];

export function loadEnvironmentHook(nextState) {
	const path = nextState?.path;

	if (path) {
		backofficeEnvironmentConfigs.forEach(config => {
			const configApplies = config.pathPrefixes.some(pathPrefix => path.includes(pathPrefix));

			if (configApplies) {
				loadEnvironment(config.environmentIdentifier);
			}
		});
	}

	return HOOK_SKIPPED;
}
